import React from 'react'
import { Tooltip } from 'primereact/tooltip';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Card } from 'primereact/card';
import { useDateFormatter } from "../../Components/FormatDateTime";
import { removePlusFromNum } from '../../Components/CleanInputs';
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import { Tag } from 'primereact/tag';
import AutoBillingBadge from '../../Components/AutoBillingBadge';

const renderAudienceCriteriaPills = (segments = [], tags = [], t) => {
      const hasCriteria = segments.length > 0 || tags.length > 0;

      if (!hasCriteria) {
            return (
                  <p className="planDetailCard-group-name audience-criteria-empty mb-0 ml-2">
                        {t("business_customers.no_criteria_specified")}
                  </p>
            );
      }

      return (
            <div className="audience-criteria-pill-group ml-2">
                  {segments.length > 0 && (
                        <div className="audience-criteria-row flex flex-wrap gap-2">
                              {segments.map((item) => {
                                    const label = item?.segment?.label ?? item?.segment?.name ?? item?.label ?? item?.name ?? "";
                                    if (!label) {
                                          return null;
                                    }
                                    return (
                                          <span key={`segment-${item.id}`} className="segment-tag-div">
                                                <span className="segment-class">{label}</span>
                                          </span>
                                    );
                              })}
                        </div>
                  )}
                  {tags.length > 0 && (
                        <div className="audience-criteria-row flex flex-wrap gap-2">
                              {tags.map((item) => {
                                    const label = item?.tag?.label ?? item?.tag?.name ?? item?.label ?? item?.name ?? "";
                                    if (!label) {
                                          return null;
                                    }
                                    return (
                                          <span key={`tag-${item.id}`} className="tag-div-main">
                                                <span className="tag-class">{label}</span>
                                          </span>
                                    );
                              })}
                        </div>
                  )}
            </div>
      );
};

const LargeCard = ({ page, name, phoneNo, refTitle, cusNumTitle, segmentName, tags,
      email, cusNum, reference, props, updatedOn,
      createdOn, planDetState, t, defMembership, createdDate,
      lastModifiedDate, productAccountBalances, withdrawalState, subscribers, subscriptionLastModifiedOnDate, subscriptionCreatedOnDate,
      audienceDetState, importedDate, hasBeenModified, modifiedDate, statusLabel, statusClass,
      candidateSegments = [], candidateTags = [], criteriaLoading = false, displayMemberCount,
      linkStatus, linkStatusClass, canManageTags, onRemoveTag,
      enrichmentDetState, completedOnFormatted, entryCountDisplay,
      pendingCountDisplay, unmatchedCountDisplay, hasSummaryDetails,
      showSecondariesCue, showLinkedPlansCue, secondariesCount, linkedPlansCount,
      secondariesCueLabel, linkedPlansCueLabel, onSecondariesCueClick, onLinkedPlansCueClick }) => {

      const { formatDate } = useDateFormatter();

      const { currencyFormat, currencySymbol } = useCurrencyConstants();

      //This (item)screen has been commented out for now but might be needed in the future
      // const currencySymbolProps = props?.defMembership?.business.currency || ''

      const providedService = defMembership?.business.purpose;

      return (
            <div className='col-12'>
                  <Card className='p-2' id='large-card-container' >
                        {page === "subscriber-detail" && (<div className='grid p-2 subscriber-detail-header-grid'>
                              <div className='col-12 md:col-6 flex flex-column'>
                                    {linkStatus && (
                                          <span className={linkStatusClass || "customer-link-badge"}>
                                                {linkStatus}
                                          </span>
                                    )}
                                    <p className='name-label mb-0'>{name}</p>
                                    <p className='contact-label-phoneNo mb-0'>{removePlusFromNum(phoneNo)}</p>
                                    <p className='contact-label-email'>{email}</p>

                                    {segmentName ? <div className="segment-tag-div">
                                          <p span className="segment-class">{segmentName}</p>
                                    </div> : null}

                                    {tags?.length > 0 || showSecondariesCue || showLinkedPlansCue ? (
                                          <div className="subscriber-detail-tags-panel">
                                                {tags?.length > 0 ? (
                                                      <div className="tags-container mt-3">
                                                            {tags.map(tag => (
                                                                  <Tag className="tag-div-main" key={tag.id}>
                                                                        <div className="tag_div">
                                                                              <span className="tag-class">{tag.name}</span>
                                                                              {canManageTags ? (
                                                                                    <i
                                                                                          className="pi pi-times-circle pl-1 tag-close-icon cursor-pointer"
                                                                                          onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                onRemoveTag?.(tag);
                                                                                          }}
                                                                                    ></i>
                                                                              ) : null}
                                                                        </div>
                                                                  </Tag>
                                                            ))}
                                                      </div>
                                                ) : null}
                                                {(showSecondariesCue || showLinkedPlansCue) ? (
                                                      <div className="subscriber-detail-relation-cues">
                                                            {showSecondariesCue ? (
                                                                  <button
                                                                        type="button"
                                                                        className="subscriber-detail-relation-cue subscriber-detail-relation-cue--secondaries"
                                                                        onClick={onSecondariesCueClick}
                                                                  >
                                                                        <span className="subscriber-detail-relation-cue__count">
                                                                              {secondariesCount}
                                                                        </span>
                                                                        <span>{secondariesCueLabel}</span>
                                                                  </button>
                                                            ) : null}
                                                            {showLinkedPlansCue ? (
                                                                  <button
                                                                        type="button"
                                                                        className="subscriber-detail-relation-cue subscriber-detail-relation-cue--plans"
                                                                        onClick={onLinkedPlansCueClick}
                                                                  >
                                                                        <span className="subscriber-detail-relation-cue__count">
                                                                              {linkedPlansCount}
                                                                        </span>
                                                                        <span>{linkedPlansCueLabel}</span>
                                                                  </button>
                                                            ) : null}
                                                      </div>
                                                ) : null}
                                          </div>
                                    ) : null}
                              </div>

                              <div className='col-12 md:col-6 flex flex-column'>
                                    <div className='flex'><p className='sub-label mb-0'>{refTitle}:</p><p className='ref-label pl-1'>{cusNum}</p></div>
                                    <div className='flex'><p className='sub-label mb-0'>{cusNumTitle}:</p><p className='ref-label pl-1'>{reference}</p></div>
                              </div>

                        </div>)}

                        {page === "product-detail" && (<div className="product-main-card grid">
                              <div className="col-12">
                                    <div className="grid product-detail-meta-grid align-items-center">
                                          <div className="col-12 sm:col-4 md:col-3">
                                                {props.state.planGroup.exclusive ? <p className="exclusive-tag">{props.t("products.EXCLUSIVE")}</p> :
                                                      <p className="non-exclusive-tag">{props.t("products.NON-EXCLUSIVE")}</p>}
                                          </div>
                                          <div className="col-12 sm:col-8 md:col-9">
                                                <div className="product-info-dates">
                                                      <span className={`planCard-badge product-status status-${props.state.planGroup.status?.toLowerCase()}`}>{props.state.planGroup.status}</span>
                                                      {createdOn === updatedOn && <div> <span className="planCard-date">
                                                            {props.t("product.created_on")}{":"}</span>
                                                            <span className="planModifiedDate">{formatDate(createdOn)}</span>
                                                      </div>}
                                                      {createdOn !== updatedOn && <div><span className="planCard-date">
                                                            {props.t("product.updated_on")}{":"}</span>
                                                            <span className="planModifiedDate">{formatDate(updatedOn)}</span>
                                                      </div>}
                                                </div>
                                          </div>
                                    </div>
                                    <div className="product-detail-name-row">
                                          {props.state.planGroup.status === "ARCHIVED" && <div>
                                                <i className="pi pi-lock" id="archived_icon"></i>
                                          </div>}
                                          <div className="product-name-desc" >
                                                <span className="productCard-name">{props.state.planGroup.name}</span>
                                                <span className="planCard-dec">{props.state.planGroup.description}</span>
                                          </div>
                                    </div>
                              </div>
                              {/* This (item)screen has been commented out for now but might be needed in the future */}
                              {/* <div className="col-5 balance-side-div">
                                    <div className="balance-main-div">
                                          <span id="balance_label">{props.t("product.collected_balance_label")}{":"}</span>&nbsp;
                                          <FormatCurrency
                                                amount={props.state.performance.balance}
                                                currencySymbol={currencySymbolProps}
                                                currencyFormat={currencyFormat}
                                                className="balance-value"
                                          />
                                    </div>
                                    <div className="available_pending">
                                          <div className="available-main-div">
                                                <span id="available_label">{props.t("product.available")}{":"}</span>&nbsp;
                                                <FormatCurrency
                                                      amount={props.state.performance.available}
                                                      currencySymbol={currencySymbolProps}
                                                      currencyFormat={currencyFormat}
                                                      className="detail-card-value"
                                                />
                                          </div>
                                          <div className="pending-main-div">
                                                <span id="pending_label">{props.t("products.pending")}{":"}</span>&nbsp;
                                                <FormatCurrency
                                                      amount={props.state.performance.pending}
                                                      currencySymbol={currencySymbolProps}
                                                      currencyFormat={currencyFormat}
                                                      className="detail-card-value"
                                                />
                                          </div>
                                    </div>
                              </div> */}
                        </div>)}

                        {page === "plan-detail" && (
                              <div className='grid nested-grid main-card plan-detail-header-card'>
                                    <section className='col-12 lg:col-6'>
                                          <div className='col-12'>
                                                <div className='flex flex-wrap align-items-center gap-2'>
                                                      {
                                                            planDetState.plan?.status === "ARCHIVED" ?
                                                                  <span className="status-archived" >
                                                                        {planDetState.plan?.status}
                                                                  </span> : <span className="planDetailCard-badge status-active">
                                                                        {planDetState.plan.status}
                                                                  </span>
                                                      }

                                                      <div className='archive-info text-center' >
                                                            {createdDate !== lastModifiedDate && <p>
                                                                  <span className='date-label'>{t("product.updated_on")}{":"}</span> <span className="planModifiedDate">{" "}{lastModifiedDate}</span>
                                                            </p>}
                                                            {createdDate === lastModifiedDate && <p>
                                                                  <span className='date-label'>{t("product.created_on")}{":"}</span> <span className="planModifiedDate">{" "}{createdDate}</span>
                                                            </p>}
                                                      </div>
                                                </div>
                                          </div>
                                          <div className='col-12'>
                                                <div className='flex align-items-center gap-2 flex-wrap'>
                                                      <p className='planDetailCard-name '>{planDetState.plan.name}</p>
                                                      <AutoBillingBadge collectionMode={planDetState.plan.collectionMode} />
                                                </div>
                                                <p className='planDetailCard-dec desc-info '>{planDetState.plan.description}</p>
                                                <p className='planDetailCard-group-name '>{planDetState.plan.group?.name?.toUpperCase()}</p>
                                          </div>
                                    </section>
                                    <section className='col-12 lg:col-6'>
                                          <div className='col-12 plan-type mb-0'>
                                                {planDetState.plan.policy === "TARGET" ? (<div className='flex flex-wrap'>
                                                      <span className="text-left policy target-special">
                                                            {t("products.target-billing")}
                                                      </span>
                                                      {planDetState.plan.policy === "TARGET"
                                                            && <span className="text-left policy target-stat target-special mb-0 mr-1">
                                                                  {planDetState.plan.targetEqualParts ? t("product.equal") : t("product.varying")}</span>}
                                                      {(planDetState.plan.targetEqualParts && planDetState.plan.recoverMissed)
                                                            && <span className="text-left policy target-special target-stat-miss mb-0">{t('product.recovery')}</span>}
                                                </div>
                                                ) : (
                                                      <span className="planDetailCard-side-amount">
                                                            {planDetState.plan.policy === "FLEXIBLE"
                                                                  ? t("products.flexible_amount")
                                                                  : planDetState.plan.policy === "CUSTOM"
                                                                        ? t("products.custom_billing").toUpperCase()
                                                                        : t("products.fixed-billing")}
                                                      </span>
                                                )}
                                          </div>
                                          <div className='col-12'>
                                                <div className='grid plan-detail-meta-grid'>
                                                      <div className='col-12 sm:col-6'>
                                                            <div className="planDetailCard-side-info mt-0">
                                                                  {t("price")}:
                                                                  <div>
                                                                        {planDetState.plan.policy === "TARGET" ?
                                                                              <p className='ml-1' style={{ fontSize: "12px", color: "#d0021b" }}>
                                                                                    {t("products.target-fixed")}
                                                                              </p>
                                                                              :
                                                                              planDetState.plan.cost ? (
                                                                                    <FormatCurrency
                                                                                          amount={planDetState.plan.cost}
                                                                                          currencySymbol={currencySymbol}
                                                                                          currencyFormat={currencyFormat}
                                                                                          className="planDet-cost ml-1"
                                                                                    />
                                                                              ) : planDetState.plan.flex ?
                                                                                    (<p className='ml-1' style={{ fontSize: "12px", color: "#d0021b" }}>
                                                                                          {t("products.flexible-amount")}
                                                                                    </p>) : (
                                                                                          <p className='ml-1' style={{ fontSize: "12px", color: "#d0021b" }}>
                                                                                                {t("fixed_sub")}
                                                                                          </p>
                                                                                    )}
                                                                  </div>
                                                            </div>
                                                            <p className="planDetailCard-side-info">
                                                                  {<>{t("billing_period")}:<span>{planDetState.plan.billingPeriod ? t(`product.${planDetState.plan.billingPeriod.toLowerCase()}`) : "--"}</span>
                                                                  </>}
                                                            </p>
                                                            <p className="planDetailCard-side-info">
                                                                  <>{t("grace_period")} : <span>{planDetState.plan.graceDays ? planDetState.plan.graceDays : t("none")}</span></>
                                                                  <span style={{ margin: "0 0 0 2px" }}>{planDetState.plan.graceDays ? t("days") : null} </span>
                                                            </p>
                                                      </div>
                                                      <div className='col-12 sm:col-6'>
                                                            {planDetState.plan.setup && <div className="setup_fee_div" style={{ marginTop: "0.5rem" }}>
                                                                  <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                                                                  <FormatCurrency
                                                                        amount={planDetState.plan.setup}
                                                                        currencySymbol={currencySymbol}
                                                                        currencyFormat={currencyFormat}
                                                                        className="setup_fee_value"
                                                                  />
                                                            </div>}
                                                            <p className="planDetailCard-side-info mt-1">
                                                                  {<>{providedService === "SERVICES" ? t("plan.num_payments") : t("plan.num_donations")}:
                                                                        <span>{planDetState?.plan.billingPeriod === "ONCE" ?
                                                                              t("plan.period_ONCE") : planDetState.plan?.deductions ? planDetState.plan.deductions : t("forever")}</span></>}
                                                            </p>
                                                            <p className="planDetailCard-side-info">
                                                                  <>{t("product.reminderDaysLabel")} : <span>{planDetState.plan.reminderDays ? planDetState.plan.reminderDays : t("none")}</span></>
                                                                  <span style={{ margin: "0 0 0 2px" }}>{planDetState.plan.reminderDays ? t("days") : null} </span>
                                                            </p>
                                                      </div>
                                                </div>
                                          </div>
                                    </section>
                              </div>
                        )}

                        {page === "enrichment-detail" && (
                              <div className='grid nested-grid main-card enrichment-detail-header-card'>
                                    <section className='col-12 lg:col-6'>
                                          {hasSummaryDetails && completedOnFormatted ? (
                                                <div className='col-12'>
                                                      <p className="mb-0">
                                                            <span className='planCard-date'>{t("business_customers.enrichment_completed_on")}{":"}</span>
                                                            <span className="planModifiedDate">{" "}{completedOnFormatted}</span>
                                                      </p>
                                                </div>
                                          ) : null}
                                          <div className='col-12'>
                                                <p className='planDetailCard-name'>
                                                      {enrichmentDetState?.summary?.requestId ?? enrichmentDetState?.requestId}
                                                </p>
                                                {hasSummaryDetails ? (
                                                      <>
                                                            <p className="planDetailCard-side-info mt-2 mb-0">
                                                                  {t("business_customers.enrichment_entry_count")}:<span>{entryCountDisplay}</span>
                                                            </p>
                                                            <p className="planDetailCard-side-info mb-0">
                                                                  {t("business_customers.enrichment_pending_count")}:<span>{pendingCountDisplay}</span>
                                                            </p>
                                                      </>
                                                ) : null}
                                          </div>
                                    </section>
                                    {hasSummaryDetails ? (
                                          <section className='col-12 lg:col-6'>
                                                <div className='col-12'>
                                                      <p className="planDetailCard-side-info mt-0 mb-0">
                                                            {t("business_customers.enrichment_unmatched_count")}:<span>{unmatchedCountDisplay}</span>
                                                      </p>
                                                </div>
                                          </section>
                                    ) : null}
                              </div>
                        )}

                        {page === "audience-detail" && (
                              <div className='grid nested-grid main-card'>
                                    <section className='col-12 xl:col-6'>
                                          <div className='col-12 audience-detail-date-row'>
                                                {!hasBeenModified ? (
                                                      <p className="mb-2">
                                                            <span className='planCard-date'>{t("product.created_on")}{":"}</span>
                                                            <span className="planModifiedDate">{" "}{importedDate}</span>
                                                      </p>
                                                ) : (
                                                      <p className="mb-2">
                                                            <span className='planCard-date'>{t("product.updated_on")}{":"}</span>
                                                            <span className="planModifiedDate">{" "}{modifiedDate}</span>
                                                      </p>
                                                )}
                                          </div>
                                          <div className='col-12'>
                                                <p className='planDetailCard-name '>
                                                      {audienceDetState.audience?.importName || audienceDetState.audience?.name}
                                                </p>
                                                <p className='planDetailCard-dec desc-info '>
                                                      {audienceDetState.audience?.externalId}
                                                </p>
                                                <p className="planDetailCard-side-info mt-2 mb-0">
                                                      {t("business_customers.audience_detail_total_entries")}:<span>{audienceDetState.audience?.entryCount ?? 0}</span>
                                                </p>
                                                <p className="planDetailCard-side-info mb-0">
                                                      {t("business_customers.audience_detail_members_added")}:<span>{displayMemberCount ?? audienceDetState.audience?.memberCount ?? 0}</span>
                                                </p>
                                          </div>
                                    </section>
                                    <section className='col-12 xl:col-6'>
                                          <div className='col-12'>
                                                <p className="insights audience-criteria-heading mb-2">
                                                      {t("business_customers.audience_membership_criteria")}
                                                </p>
                                                {criteriaLoading ? (
                                                      <ProgressSpinner style={{ width: "24px", height: "24px" }} />
                                                ) : (
                                                      renderAudienceCriteriaPills(candidateSegments, candidateTags, t)
                                                )}
                                          </div>
                                    </section>
                              </div>
                        )}

                        {page === "subscription-detail" && (<div className='grid subscription-detail-header-grid'>
                              <section className='col-12 lg:col-6'>
                                    <div className='col-12'>
                                          <div className='flex '>
                                                <span className={`planDetailCard-badge status-${subscribers.status?.toLowerCase()} status-design`}>
                                                      {subscribers.status}
                                                </span>
                                                <div className='archive-info text-center' >
                                                      {subscriptionCreatedOnDate !== subscriptionLastModifiedOnDate && <p>
                                                            <span className='date-label'>{t("product.updated_on")}{":"}</span> <span className="planModifiedDate">{" "}{subscriptionLastModifiedOnDate}</span>
                                                      </p>}
                                                      {subscriptionCreatedOnDate === subscriptionLastModifiedOnDate && <p>
                                                            <span className='date-label'>{t("product.created_on")}{":"}</span> <span className="planModifiedDate">{" "}{subscriptionCreatedOnDate}</span>
                                                      </p>}
                                                </div>
                                          </div>
                                    </div>
                                    <div className='col-12'>
                                          <div className='flex'>
                                                <p className='subscriptionDetailCard-phoneNo '>{removePlusFromNum(subscribers.businessCustomer?.phoneNo)}</p>
                                                <p className='subscriptionDetailCard-stroke mr-2 ml-2'>|</p>
                                                <p className='subscriptionDetailCard-name'>{subscribers.businessCustomer?.name}</p>
                                          </div>
                                          <div className='flex align-items-center gap-2'>
                                                <p className='planDetailCard-name '>{subscribers.plan && subscribers.plan.name}</p>
                                                <AutoBillingBadge collectionMode={subscribers.plan?.collectionMode} />
                                          </div>
                                          <p className='planDetailCard-dec desc-info '>{subscribers.plan && subscribers.plan.description}</p>
                                          <p className='planDetailCard-group-name '>{subscribers.plan && subscribers.plan.groupName.toUpperCase()}</p>
                                    </div>
                              </section>
                              <section className='col-12 lg:col-6'>
                                    <div className='col-12 plan-type mb-0'>
                                          {subscribers?.plan?.policy === "TARGET" ? (<div className='flex'>
                                                <span className="text-left policy target-special">
                                                      {t("products.target-billing")}
                                                </span>
                                                {subscribers?.plan?.policy === "TARGET"
                                                      && <span className="text-left policy target-stat target-special mb-0 mr-1">
                                                            {subscribers?.plan.targetEqualParts ? t("product.equal") : t("product.varying")}</span>}
                                                {(subscribers?.plan?.targetEqualParts && subscribers?.plan?.recoverMissed)
                                                      && <span className="text-left policy target-special target-stat-miss mb-0">{t('product.recovery')}</span>}
                                          </div>
                                          ) : (
                                                <span className="planDetailCard-side-amount">
                                                      {subscribers.plan?.policy === "FLEXIBLE"
                                                            ? t("products.flexible_amount")
                                                            : subscribers.plan?.policy === "CUSTOM"
                                                                  ? t("products.custom_billing").toUpperCase()
                                                                  : t("products.fixed-billing")}
                                                </span>
                                          )}
                                    </div>
                                    <div className='col-12 pb-0'>
                                          <div className="planDetailCard-side-info mt-0">
                                                <>{t("subscriber.subs_id")}: <p className='ml-1' style={{ color: "#9747ff", fontWeight: "bold" }}>
                                                      {subscribers.subscriberReference}</p>
                                                </>
                                          </div>
                                    </div>

                                    <div className='col-12'>
                                          <div className='grid subscription-detail-plan-meta-grid'>
                                                <div className='col-12 md:col-6'>
                                                      <div className="planDetailCard-side-info">
                                                            <>{t("price")}: {subscribers?.plan?.policy === "CUSTOM" ?
                                                                  <p className='ml-1 flex_label'>
                                                                        {t("fixed_sub")}
                                                                  </p> : subscribers?.plan?.policy === "FLEXIBLE" ? <p className='ml-1 flex_label'>{t("subscriber.flex_true")}</p>
                                                                        : (subscribers.plan?.policy === "TARGET") ?
                                                                              <FormatCurrency
                                                                                    amount={subscribers.target}
                                                                                    currencySymbol={currencySymbol}
                                                                                    currencyFormat={currencyFormat}
                                                                                    id="subs-cost"
                                                                              /> : (subscribers.plan?.cost) &&
                                                                              <FormatCurrency
                                                                                    amount={subscribers.plan?.cost}
                                                                                    currencySymbol={currencySymbol}
                                                                                    currencyFormat={currencyFormat}
                                                                                    id="subs-cost"
                                                                              />
                                                            }
                                                            </>
                                                      </div>
                                                      <p className="planDetailCard-side-info">
                                                            {<>{t("billing_period")}:<span>{subscribers.plan?.billingPeriod ? t(`product.${subscribers.plan?.billingPeriod.toLowerCase()}`) : t("subscriber.none")}</span>
                                                            </>}
                                                      </p>
                                                      <p className="planDetailCard-side-info">
                                                            <>{t("grace_period")} : <span>{subscribers.plan?.graceDays ? subscribers.plan?.graceDays : t("subscriber.none")}</span></>
                                                            <span style={{ margin: "0 0 0 2px" }}>{subscribers.plan?.graceDays ? t("days") : null} </span>
                                                      </p>
                                                </div>
                                                <div className='col-12 md:col-6'>
                                                      {subscribers.plan?.setup && <div className="setup_fee_div" style={{ marginTop: "0.5rem" }}>
                                                            <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                                                            <FormatCurrency
                                                                  amount={subscribers.plan?.setup}
                                                                  currencySymbol={currencySymbol}
                                                                  currencyFormat={currencyFormat}
                                                                  className="setup_fee_value"
                                                            />
                                                      </div>}
                                                      <p className="planDetailCard-side-info">
                                                            {<>{providedService === "SERVICES" ? t("plan.num_payments") :
                                                                  t("plan.num_donations")}:<span>{subscribers?.deductions === "ONCE" ? t("plan.period_ONCE") : subscribers?.deductions}</span></>}
                                                      </p>
                                                      <p className="planDetailCard-side-info">
                                                            <>{t("product.reminderDaysLabel")} : <span>{subscribers.plan?.reminderDays ? subscribers.plan?.reminderDays : t("subscriber.none")}</span></>
                                                            <span style={{ margin: "0 0 0 2px" }}>{subscribers.plan?.reminderDays ? t("days") : null} </span>
                                                      </p>
                                                </div>
                                          </div>
                                    </div>
                              </section>
                        </div>)}

                        {page === "withdrawal-list" && (<div className="grid pl-1 pr-1">
                              <div className="col-7">
                                    <div className="flex">
                                          {withdrawalState.planGroup.exclusive ? <p className={`exclusive_tag mr-2`}>{t("products.EXCLUSIVE")}</p> :
                                                <p className={`non-exclusive_tag mr-2`}>{t("products.NON-EXCLUSIVE")}</p>}
                                          <div className="flex">
                                                {(withdrawalState.planGroup.status === "ACTIVE") ? <div className="active_status stat-pill ">{withdrawalState.planGroup.status}</div> : <span className="archive_status stat-pill">{withdrawalState.planGroup.status}</span>}
                                                <div className="ml-1  text-center ">
                                                      <span className="createdOn_des ml-2">{t("transaction.created_on")}</span>{":"}{" "}
                                                      <span className="planModifiedDate">{formatDate(withdrawalState.planGroup?.createdOn)}</span>
                                                </div>
                                          </div>
                                    </div>
                                    <div className="flex flex-column text-start">
                                          <span className="font-bold  mb-1 plan-name">{withdrawalState.planGroup?.name}</span>
                                          <span className="">{withdrawalState.planGroup?.description}</span>
                                    </div>
                              </div>

                              <div className="col-5">
                                    <div className="mb-3">
                                          <span className="font-bold  bal-size">{t("Balance")}{":"}</span>
                                          <FormatCurrency
                                                amount={productAccountBalances?.balance}
                                                currencySymbol={currencySymbol}
                                                currencyFormat={currencyFormat}
                                                className="bal-value text-center"
                                          />
                                    </div>
                                    <div className="mb-1">
                                          <span className="availableTransaction">{t("available")}{":"}</span>
                                          <FormatCurrency
                                                amount={productAccountBalances?.available}
                                                currencySymbol={currencySymbol}
                                                currencyFormat={currencyFormat}
                                                className="avail-value"
                                          />
                                    </div>
                                    <div>
                                          <span className="pendingTransaction">{t("pending")}{":"}</span>
                                          <FormatCurrency
                                                amount={productAccountBalances?.pendingWthdlAmount}
                                                currencySymbol={currencySymbol}
                                                currencyFormat={currencyFormat}
                                                className="avail-value"
                                          />
                                    </div>
                              </div>
                        </div>)}
                  </Card>
            </div>
      )
}

const ProductCards = ({ style, title, value, subDesc, cardInfo, className }) => {

      const titleValue = (val, title) => {
            if ((title === "Subscriptions" || title === "Payments" || title === "Withdrawals") && val) {
                  return "";
            }
            else if ((title === "Subscriptions" || title === "Payments" || title === "Withdrawals") && !val) {
                  return "";
            }
            else if ((title !== "Subscriptions" || title !== "Payments" || title !== "Withdrawals") && val) {
                  return val
            }
            else if ((title !== "Subscriptions" || title !== "Payments" || title !== "Withdrawals") && !val) {
                  return 0
            }
      }

      return (
            <div className='col-3'>
                  <div className="product_cards">
                        <div className='grid'>
                              <div className="col-10" style={{ display: "flex", flexDirection: "column" }}>
                                    <span className={`product-card-titles + ${style} ${className}`}>{title}</span>
                                    <span className="product-card-text">{titleValue(value, title)}</span>
                                    <span className="product-summary-card-subDesc">{subDesc}</span>
                              </div>

                              <div className="col-2">
                                    <Tooltip target=".custom-target-icon" />
                                    {cardInfo && <i className='custom-target-icon pi pi-info-circle' id='card-info-btn' data-pr-tooltip={cardInfo}>
                                    </i>}
                              </div>
                        </div>
                  </div>
            </div>
      )
}

const ProductSummaryCards = ({ style, title, cardInfo, type,
      subsNewValue, subtitleNew, subsActiveValue, subtitleActive, subtitleCompleted,
      subsCompletedValue, subsCancelledValue, subtitleCancelled, subsPausedValue, subtitlePaused,
      missedValue, missedSubDesc, revenueValue, revenueSubDesc, collectedValue, collectedSubDesc,
      loading, subsActiveDesc, subsPausedDesc, subsNewDesc, subsCancelledDesc, subsCompletedDesc,
      processedWithdrawalValue, reversedWithdrawalValue, pendingWithdrawalValue, reversedWithdrawalDesc,
      pendingWithdrawalDesc, processedWithdrawalDesc, subCompletedDesc, subActiveDesc, subCancelledDesc,
      subPausedDesc, pendingSevenDayValue, pendingSevenDay, missedSevenDayValue, missedSevenDay,
      revenueSevenDayValue, revenueSevenDay, collectedSevenDayValue, collectedSevenDay, pendingthirtyDayValue,
      pendingthirtyDay, missedthirtyDayValue, missedthirtyDay, revenuethirtyDayValue, revenuethirtyDay,
      collectedthirtyDayValue, collectedthirtyDay, pendingLifetimeValue, pendingLifetime, missedLifetimeValue,
      missedLifetime, revenueLifetimeValue, revenueLifetime, collectedLifetimeValue, collectedLifetime,
      requestedBy, dataFromWithrawalList, dateClassName, recipient, dataFromSubscriberDetail, currency, flexAmount, defMembership,
      criteriaVariant, criteriaItems = [], onRemoveCriteriaItem, removingCriteria, emptyMessage
}) => {

      const { formatDate } = useDateFormatter();
      const { currencyFormat, currencySymbol } = useCurrencyConstants();

      return (
            <div className="col-4">
                  <div className='products-report-content' >
                        <div className='grid'>
                              <div className='col-10'>
                                    {title ? <span className={`card-titles + ${style}`}>{title}</span> : null}
                              </div>
                              <Tooltip target=".custom-target-icon" />
                              <div className='col-2'>
                                    {cardInfo && <i className='custom-target-icon pi pi-info-circle' id='card-info-btn'
                                          data-pr-tooltip={cardInfo}>
                                    </i>}
                              </div>
                        </div>
                        <div className="summary-records">
                              {type === "subs" && <div>
                                    <div className='grid'>
                                          <div className='col-6'>
                                                <div className="column-view column-view-mb">
                                                      <span className="green-success-txts">{subtitleNew}</span>
                                                      <div className="subs-flex-row">
                                                            <span className="subsValues">{subsNewValue}</span>&nbsp;
                                                            {subsNewValue > 1 ? <span className="subsTitle">{subsNewDesc}</span> :
                                                                  <span className="subsTitle">{subActiveDesc}</span>}
                                                      </div>
                                                </div>

                                                <div className="column-view column-view-mb">
                                                      <span className="yellow-progress-txts">{subtitlePaused}</span>
                                                      <div className="subs-flex-row">
                                                            <span className="subsValues">{subsPausedValue}</span>&nbsp;
                                                            {subsPausedValue > 1 ? <span className="subsTitle">{subsPausedDesc}</span> :
                                                                  <span className="subsTitle">{subPausedDesc}</span>}
                                                      </div>
                                                </div>

                                                <div className="column-view">
                                                      <span className="red-cancelled-txts">{subtitleCancelled}</span>
                                                      <div className="subs-flex-row">
                                                            <span className="subsValues">{subsCancelledValue}</span>&nbsp;
                                                            {subsCancelledValue > 1 ? <span className="subsTitle">{subsCancelledDesc}</span> :
                                                                  <span className="subsTitle">{subCancelledDesc}</span>}
                                                      </div>
                                                </div>
                                          </div>

                                          <div className='col-6'>
                                                <div className="column-view column-view-mb">
                                                      <span className="green-success-txts">{subtitleActive}</span>
                                                      <div className="subs-flex-row">
                                                            <span className="subsValues">{subsActiveValue}</span>&nbsp;
                                                            {subsActiveValue > 1 ? <span className="subsTitle">{subsActiveDesc}</span> :
                                                                  <span className="subsTitle">{subActiveDesc}</span>}
                                                      </div>
                                                </div>

                                                <div className="column-view">
                                                      <span className="grey-completed-txt">{subtitleCompleted} </span>
                                                      <div className="subs-flex-row">
                                                            <span className="subsValues">{subsCompletedValue}</span>&nbsp;
                                                            {subsCompletedValue > 1 ? <span className="subsTitle">{subsCompletedDesc}</span> :
                                                                  <span className="subsTitle">{subCompletedDesc}</span>}
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>}

                              {type === "payments" && <div>
                                    <div className="grid">
                                          <div className="col-6">
                                                <div >
                                                      <span className="green-success-txts">{collectedSubDesc}</span>
                                                      <span>{collectedValue}</span>
                                                </div>
                                                <div style={{ marginTop: "1rem" }}>
                                                      <span className="red-cancelled-txts">{missedSubDesc}</span>
                                                      <span>{missedValue}</span>
                                                </div>
                                          </div>
                                          <div className="col-6">
                                                <span className="blue-revenue-txt">{revenueSubDesc}</span>
                                                <span>{revenueValue}</span>
                                          </div>
                                    </div>
                              </div>}

                              {type === "withdrawals" && <div>
                                    <div className="grid">
                                          <div className="col-6">
                                                <div>
                                                      <span className="green-success-txts">{processedWithdrawalDesc}</span>
                                                      <span>{processedWithdrawalValue}</span>
                                                </div>

                                                <div style={{ marginTop: "1rem" }}>
                                                      <span className="red-cancelled-txts">{reversedWithdrawalDesc}</span>
                                                      <span>{reversedWithdrawalValue}</span>
                                                </div>
                                          </div>
                                          <div className="col-6">
                                                <div>
                                                      <span className="yellow-progress-txts">{pendingWithdrawalDesc}</span>
                                                      <span>{pendingWithdrawalValue}</span>
                                                </div>
                                          </div>
                                    </div>
                              </div>}

                              {type === "payments-7" && <div>
                                    <div className="grid">
                                          <div className="col-6">
                                                <div>
                                                      <span className="green-success-txts">{collectedSevenDay}</span>
                                                      <span>{collectedSevenDayValue}</span>
                                                </div>
                                                <div style={{ marginTop: "1rem" }}>
                                                      <span className="red-cancelled-txts">{missedSevenDay}</span>
                                                      <span>{missedSevenDayValue}</span>
                                                </div>
                                          </div>
                                          <div className="col-6">
                                                <div>
                                                      <span className="blue-revenue-txt">{revenueSevenDay}</span>
                                                      <span>{revenueSevenDayValue}</span>
                                                </div>
                                          </div>
                                    </div>
                              </div>}

                              {type === "payments-30" && <div>
                                    <div className="grid">
                                          <div className="col-6">
                                                <div>
                                                      <span className="green-success-txts">{collectedthirtyDay}</span>
                                                      <span>{collectedthirtyDayValue}</span>
                                                </div>
                                                <div style={{ marginTop: "1rem" }}>
                                                      <span className="red-cancelled-txts">{missedthirtyDay}</span>
                                                      <span>{missedthirtyDayValue}</span>
                                                </div>
                                          </div>
                                          <div className="col-6">
                                                <div>
                                                      <span className="blue-revenue-txt">{revenuethirtyDay}</span>
                                                      <span>{revenuethirtyDayValue}</span>
                                                </div>
                                          </div>
                                    </div>
                              </div>}

                              {type === "lifetime" && <div>
                                    <div className="grid">
                                          <div className="col-6">
                                                <div>
                                                      <span className="green-success-txts">{collectedLifetime}</span>
                                                      <span>{collectedLifetimeValue}</span>
                                                </div>
                                                <div style={{ marginTop: "1rem" }}>
                                                      <span className="red-cancelled-txts">{missedLifetime}</span>
                                                      <span>{missedLifetimeValue}</span>
                                                </div>
                                          </div>
                                          <div className="col-6">
                                                <div>
                                                      <span className="blue-revenue-txt">{revenueLifetime}</span>
                                                      <span>{revenueLifetimeValue}</span>
                                                </div>

                                          </div>
                                    </div>
                              </div>}

                              {type === "audience-criteria" && (
                                    criteriaVariant === "empty" ? (
                                          <p className="planDetailCard-group-name audience-criteria-empty mb-0">{emptyMessage}</p>
                                    ) : (
                                          <div className="audience-criteria-pill-group ml-2 flex flex-wrap gap-2">
                                                {criteriaItems.map((item) => {
                                                      const label = criteriaVariant === "segment"
                                                            ? (item?.segment?.label ?? item?.segment?.name ?? item?.label ?? item?.name ?? "")
                                                            : (item?.tag?.label ?? item?.tag?.name ?? item?.label ?? item?.name ?? "");
                                                      if (!label) {
                                                            return null;
                                                      }
                                                      const pillClassName = criteriaVariant === "segment"
                                                            ? "segment-tag-div"
                                                            : "tag-div-main";
                                                      return (
                                                            <span key={`${criteriaVariant}-${item.id}`} className={pillClassName}>
                                                                  {criteriaVariant === "segment" ? (
                                                                        <span className="segment-class">{label}</span>
                                                                  ) : (
                                                                        <span className="tag-class">{label}</span>
                                                                  )}
                                                            </span>
                                                      );
                                                })}
                                          </div>
                                    )
                              )}

                              {`${type}` && type !== "audience-criteria" && <div>
                                    {dataFromSubscriberDetail?.map((row, i) => {
                                          const { receivedAt, amount, cost, plan, subscription, latestDlr, scheduledFor } = row || {};
                                          const insightDate = type === "subscriber-details-1"
                                                ? scheduledFor
                                                : type === "subscriber-details-2"
                                                      ? receivedAt
                                                      : type === "subscriber-details-3"
                                                            ? (scheduledFor || latestDlr?.dispatchedOn)
                                                            : null;
                                          const formattedDate = formatDate(insightDate);
                                          return (
                                          <div key={i} className="grid space-bottom">
                                                {formattedDate ? (
                                                <div className="col-6 pb-0">
                                                      <p className={`pb-0 mb-0 ${dateClassName}`}>
                                                            {formattedDate}
                                                      </p>
                                                </div>
                                                ) : null}
                                                <div className={`${formattedDate ? "col-6" : "col-12"} pb-0`}>
                                                      {subscription?.plan?.flex ? (
                                                            <p className="pb-0 mb-0 account_name">{flexAmount}</p>
                                                      ) : (
                                                            <FormatCurrency
                                                                  amount={(cost || amount)}
                                                                  currencySymbol={currencySymbol}
                                                                  currencyFormat={currencyFormat}
                                                                  className="pb-0 mb-0 account_name"
                                                            />
                                                      )}
                                                </div>

                                                <div className="col-12 pt-0">
                                                      <p className="pending-value pb-0">{subscription?.plan?.name || plan?.name}</p>
                                                </div>
                                          </div>
                                          );
                                    })}
                              </div>
                              }

                              {`${type}` && type !== "audience-criteria" && <div>
                                    <div className="grid">
                                          <div className="col-12">
                                                <div className="grid">
                                                      {dataFromWithrawalList?.map(({ requestedOn, amount, channel, requestedByName }, i) => (
                                                            <div key={i} className="grid nested-grid space-bottom">
                                                                  <div className="grid col-12 pb-0">
                                                                        <p className={`col-6 pb-0 mb-0 ${dateClassName}`}>
                                                                              {formatDate(requestedOn)}
                                                                        </p>
                                                                        <FormatCurrency
                                                                              amount={amount}
                                                                              currencySymbol={currencySymbol}
                                                                              currencyFormat={currencyFormat}
                                                                              className="col-6 pb-0 mb-0 account_name"
                                                                        />
                                                                  </div>
                                                                  <div className="col-12 flex pt-0 pb-0">
                                                                        <p className="requested-info mb-0 mt-0 mr-1">{requestedBy}:</p>
                                                                        <p className="pending-value mb-0">{requestedByName}</p>
                                                                  </div>
                                                                  <div className="col-12 flex pt-0 mb-1">
                                                                        <p className="requested-info mb-0 mt-0 mr-1">{recipient}:</p>
                                                                        <p className="pending-value mb-0">{channel?.name}</p>
                                                                  </div>
                                                            </div>
                                                      ))}
                                                </div>
                                          </div>
                                    </div>
                              </div>}

                              {loading ? <div className="card flex justify-content-center">
                                    <ProgressSpinner id="progress-spinner" />
                              </div> : <></>}
                        </div>
                  </div>
            </div>
      )
}

export const FullWidthCardTemplate = ({ summary, loading }) => {
      return (
            <>
                  {summary.map((summaryContent, i) => (
                        <LargeCard {...summaryContent} loading={loading} key={i} />
                  ))}

            </>
      )
}

export const SmallCardTemplate = ({ summary, loading, }) => {
      return (
            <>
                  {summary.map((summaryContent, index) => (
                        <ProductCards{...summaryContent} loading={loading} key={index} />
                  ))}
            </>
      )
}

export const MediumCardTemplate = ({ summary, header = "", loading, }) => {
      return (
            <>
                  {
                        summary.map((productsSummaryContent, i) => (
                              <ProductSummaryCards{...productsSummaryContent} loading={loading} key={i} />
                        ))
                  }
            </>
      )
}